import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../components/Axios";

export const fetchSentences = createAsyncThunk("sentences/fetch", async (arg, thunkAPI) => {
  const response = await axios.get("/video_project/" + arg + "/sentences");
  return response.data;
});

// handle actions in reducers
export const sentences = createSlice({
  name: "sentences",
  initialState: { loading: "idle", items: [], id: null },
  reducers: {
    addRange: (state, action) => {
      state.items[action.payload.id].ranges.push(action.payload.range);
      return state;
    },
    removeRange: (state, action) => {
      state.items[action.payload.item_index].ranges.splice(action.payload.range_index, 1);
      return state;
    },
    setRange: (state, action) => {
      state.items[action.payload.item_index].ranges = action.payload.ranges;
      return state;
    },
    clearRange: (state, action) => {
      for (let i in state.items) {
        state.items[i].ranges = [];
      }
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSentences.fulfilled, (state, action) => {
      state.loading = "idle";

      //update if already loaded
      if (state.id === action.meta.arg) {
        for (let i in action.payload) {
          state.items[i].text = action.payload[i].text;
          state.items[i].char_id = action.payload[i].char_id;
        }
      } else {
        //create
        state.id = action.meta.arg;
        state.items = action.payload;
        for (let i in state.items) {
          state.items[i].ranges = [];
          state.items[i].index = i;
        }
      }
    });
    builder.addCase(fetchSentences.pending, (state, action) => {
      state.loading = "pending";
    });
  },
});
